"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

var _commonReact = require("@devsta/common-react");

var _OutputDetails = _interopRequireDefault(require("./OutputDetails"));

var _utils = require("../../../../../../../common/utils");

require("../styles/_output.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SMALL_BREAKPOINT = 1040;
var ASPECT_RATIO_HEIGHT_MAP = {
  WIDE: '132px',
  SQUARE: '235px',
  INSTA: '418px',
  STANDARD: '176px'
};

function handleOutputNotesChange(onNotesChange, outputId) {
  return function (event) {
    onNotesChange(outputId, event.target.value);
  };
}

function Output(_ref) {
  var containerSize = _ref.size,
      versions = _ref.versions,
      aspectRatio = _ref.aspectRatio,
      onChangeAddon = _ref.onChangeAddon,
      addSrt = _ref.addSrt,
      updateSrt = _ref.updateSrt,
      assets = _ref.assets,
      canUpdateOutput = _ref.canUpdateOutput,
      CAPTION_SAMPLES = _ref.CAPTION_SAMPLES,
      getAddonsCost = _ref.getAddonsCost,
      isMaster = _ref.isMaster,
      notes = _ref.notes,
      outputId = _ref.outputId,
      onNotesChange = _ref.onNotesChange;
  var appliedAddons = versions[0].appliedAddons;
  var estimatedCost = getAddonsCost(appliedAddons, {
    numberValue: false,
    isMaster: isMaster
  });
  var total = {
    size: 213456789,
    duration: 1000
  };
  var readableDuration = (0, _utils.convertSecondsToReadable)(total.duration, {
    hideMillis: true
  });
  var totalQuantity = "".concat(assets.length, " ").concat(assets.length === 1 ? 'Asset' : 'Assets');
  var totalSize = "Total Size ".concat((0, _getDisplayBytes.default)(total.size));
  var totalDuration = "Est Duration ".concat(readableDuration, " min");
  var smallView = containerSize.width < SMALL_BREAKPOINT;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('output', {
        'output--small': smallView
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "output__preview"
    }, appliedAddons.BURN_IN_CAPTIONS ? /*#__PURE__*/_react.default.createElement("p", null, "SAMPLE") : null, appliedAddons.BURN_IN_CAPTIONS ? /*#__PURE__*/_react.default.createElement("p", {
      className: "output__preview__caption"
    }, CAPTION_SAMPLES[appliedAddons.BURN_IN_CAPTIONS.value]) : null, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      width: "235px",
      height: ASPECT_RATIO_HEIGHT_MAP[aspectRatio],
      defaultImageIcon: "video",
      defaultIconColor: "regent",
      defaultIconBackground: "monkey"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "output__configure"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "output__configure__title"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "How do you want your video to be produced?")), /*#__PURE__*/_react.default.createElement("p", null, "".concat(estimatedCost, ".00"))), /*#__PURE__*/_react.default.createElement("p", {
      className: "output__configure__quantities"
    }, "".concat(totalQuantity, "  |  ").concat(totalSize, "  |  ").concat(totalDuration)), /*#__PURE__*/_react.default.createElement("p", null, "OUTPUT DETAILS"), /*#__PURE__*/_react.default.createElement(_OutputDetails.default, {
      outputWidth: containerSize.width,
      onChangeAddon: onChangeAddon,
      appliedAddons: appliedAddons,
      aspectRatio: aspectRatio,
      disabled: !canUpdateOutput
    }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
      className: "output__configure__extras"
    }, "EXTRAS"), /*#__PURE__*/_react.default.createElement("p", {
      className: "output__configure__desc"
    }, "To be applied once the video has been signed off and approved"), /*#__PURE__*/_react.default.createElement("p", {
      className: "output__configure__burn-in-title"
    }, "Burn-in Captions"), /*#__PURE__*/_react.default.createElement(_commonReact.BurnInCaptions, {
      onChangeAddon: onChangeAddon,
      addons: appliedAddons,
      disabled: !canUpdateOutput
    }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
      className: "output__configure__srt-title"
    }, "SRT Captions"), /*#__PURE__*/_react.default.createElement(_commonReact.SrtCaptions, {
      onChangeAddon: onChangeAddon,
      appliedAddons: appliedAddons,
      requestedAddons: appliedAddons,
      disabled: !canUpdateOutput,
      addSrt: addSrt,
      updateSrt: updateSrt,
      buttonText: "ADD SRT"
    }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
      className: "output__configure__notes-title"
    }, "Notes to the editor"), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
      disabled: !canUpdateOutput,
      onChange: handleOutputNotesChange(onNotesChange, outputId),
      multiline: true,
      defaultValue: notes,
      className: "output__configure__notes-text"
    })))
  );
}

var _default = (0, _react.memo)(Output);

exports.default = _default;